export const FaqAccordionItemCss = {
  accordionItem: {
    border: "none",
    marginBottom: "10px"
  },
  title: {
    background: "#000",
    color: "#fff"
  },
  body: {
    background: "#000",
    padding: "24px 25px",
    fontSize: "18px",
    color: "#ccc"
  }
};
